import { render, staticRenderFns } from "./AjanlatAdatokB1_V1.vue?vue&type=template&id=091f8918&"
import script from "./AjanlatAdatokB1_V1.vue?vue&type=script&lang=js&"
export * from "./AjanlatAdatokB1_V1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports